import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Async thunk for submitting form data
export const submitAdmissionForm = createAsyncThunk(
  'api/enquiry',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await fetch('https://api.vardaanschool.org/api/enquiry', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Failed to submit form');
      }

      return await response.json(); // Return response data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const admissionFormSlice = createSlice({
  name: 'admissionForm',
  initialState: {
    submitting: false,
    success: null,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitAdmissionForm.pending, (state) => {
        state.submitting = true;
        state.success = null;
        state.error = null;
      })
      .addCase(submitAdmissionForm.fulfilled, (state) => {
        state.submitting = false;
        state.success = 'Form submitted successfully!';
      })
      .addCase(submitAdmissionForm.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  }
});

export default admissionFormSlice.reducer;
